// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"9ca036b2","949":"054eb0d8"}[chunkId] + ".chunk.css";
};